// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/bootstrap-social.css
// module id = 586
// module chunks = 0